// Faza 2 sledzenia pozycji: dopasowanie ciagu rozpoznanych akordow do
// progresji sekcji utworu. Utrzymuje bufor ostatnich N akordow i szuka go
// jako ciaglego podciagu (cyklicznie) w progresji kazdej sekcji.

/** Dlugosc bufora ostatnich rozpoznanych akordow. */
const N = 4;

/** Ponizej tej pewnosci nie wskazujemy zadnej sekcji - lepiej milczec niz
 * wskazywac zle. */
const PROG_PEWNOSCI = 0.5;

export interface TrackerState {
  /** Indeks aktywnej sekcji, `null` = brak pewnosci. */
  activeSection: number | null;
  /** Pewnosc dopasowania 0..1. */
  confidence: number;
}

export interface SectionProgression {
  /** Akordy sekcji (znormalizowane), w kolejnosci wystepowania. */
  chords: readonly string[];
}

export interface Tracker {
  /** Podaj kolejny rozpoznany akord. Zwraca zaktualizowany stan. */
  push(chord: string): TrackerState;
  /** Reset (nowy utwor). */
  reset(): void;
}

/** Sprawdza, czy `wzorzec` wystepuje jako CIAGLY podciag w `progresja`,
 * TRAKTOWANEJ CYKLICZNIE (koniec progresji zawija sie na jej poczatek). */
function wystepujeCyklicznie(progresja: readonly string[], wzorzec: readonly string[]): boolean {
  const dl = progresja.length;
  if (dl === 0 || wzorzec.length === 0 || wzorzec.length > dl) return false;

  for (let start = 0; start < dl; start++) {
    let pasuje = true;
    for (let i = 0; i < wzorzec.length; i++) {
      if (progresja[(start + i) % dl] !== wzorzec[i]) {
        pasuje = false;
        break;
      }
    }
    if (pasuje) return true;
  }
  return false;
}

/** Tworzy tracker dla danego utworu (sekcje w kolejnosci wystepowania). */
export function createTracker(sections: readonly SectionProgression[]): Tracker {
  let bufor: string[] = [];

  return {
    push(chord: string): TrackerState {
      bufor.push(chord);
      if (bufor.length > N) bufor = bufor.slice(bufor.length - N);

      let najlepszaSekcja: number | null = null;
      let najlepszaDlugosc = 0;

      // Od najdluzszego sufiksu bufora w dol: pierwsza sekcja o danej
      // dlugosci dopasowania wygrywa (identyczne progresje -> pierwsza).
      for (let dlugosc = bufor.length; dlugosc >= 1; dlugosc--) {
        const sufiks = bufor.slice(bufor.length - dlugosc);
        for (let i = 0; i < sections.length; i++) {
          const sekcja = sections[i];
          if (!sekcja) continue;
          if (wystepujeCyklicznie(sekcja.chords, sufiks)) {
            najlepszaSekcja = i;
            najlepszaDlugosc = dlugosc;
            break;
          }
        }
        if (najlepszaSekcja !== null) break;
      }

      const confidence = najlepszaDlugosc / N;
      if (najlepszaSekcja === null || confidence < PROG_PEWNOSCI) {
        return { activeSection: null, confidence };
      }
      return { activeSection: najlepszaSekcja, confidence };
    },
    reset(): void {
      bufor = [];
    },
  };
}
